const resources = {
    lead: 'Sign in for *FREE standard shipping* on all orders.',
    signIn: 'Sign In',
    createAccount: 'Create Account',
    testLead: 'Sign in for *FREE shipping*, rewards, and a birthday gift!'
};

module.exports = function getResource(label) {
    return resources[label];
};
